  <nav aria-label="breadcrumb">
    <ol class="breadcrumb customBreadcrumb">
      <ng-container *ngFor="let crumb of breadcrumbs; let i = index">
        <app-crumb
          (crumbClicked)="onCrumbClicked($event)"
          [crumb]=crumb
          [isactive]= "(breadcrumbs.length - 1) === i"
          [enableSwitchTo]="enableSwitchTo">
        </app-crumb>
      </ng-container>
    </ol>
  </nav>
